/* A Custom which extends the TimeagoPipe to handle invalid dates gracefully
 */
import { Pipe } from '@angular/core';
import { TimeagoPipe } from 'ngx-timeago';

@Pipe({
  name: 'safeTimeago',
  standalone: false,
  pure: false,
})
export class SafeTimeagoPipe extends TimeagoPipe {
  override transform(value: any, ...args: any[]): string {
    const date = new Date(value);

    if (isNaN(date.getTime()) || date.toISOString().includes('1970')) {
      return '';
    }

    const base = super.transform(value, ...args);
    return `${base}`;
  }
}
